module.exports = __webpack_public_path__ + "static/media/sub-weapon.703f25b2.png";